<template>
	<div class="alert alert-danger">
		There was a problem with the information you entered. Please check the highlighted fields and try again.
	</div>
</template>
